<template>
  <div
    class="w-full h-full visualization-cockpit flex bg-no-repeat"
    :class="`visualization-${currentTheme}`"
  >
    <div
      class="bg-no-repeat relative w-full h-full z-10"
      :class="isPreview && isSplitScreen ? '!w-1/2' : ''"
    >
      <div
        class="visualization-cockpit-left absolute left-0 bg-no-repeat h-full z-8"
        :class="visualizationLeftClass"
        v-if="showLeftMask"
      ></div>
      <div
        class="visualization-cockpit-right absolute right-0 bg-no-repeat h-full z-8"
        :class="visualizationRightClass"
        v-if="showRightMask"
      ></div>
      <div
        v-if="showControlPanel"
        class="w-40px h-40px absolute left-20px bottom-20px z-999 control-panel transition-all cursor-pointer"
        @click="changePanel"
        :class="!collapsePanel ? 'collapse' : 'unfold'"
      ></div>
      <ModelPreview
        v-if="isPreview"
        @sendPlayer="sendPlayer"
        :modelDetail="modelDetail"
        :cloudRender="cloudRender"
        :modelEngineTransform="modelEngineTransform"
        @loadModelEnd="loadModelEnd"
        @updateModelNode="updateModelNode"
      ></ModelPreview>
      <GXModelView
        v-else-if="isGXView"
        @sendPlayer="sendPlayer"
        :GXRunPlayer="GXRunPlayer"
        :modelDetail="modelDetail"
        :cloudRender="cloudRender"
        :loadModelNode="loadModelNode"
        @loadModelEnd="loadModelEnd"
        @loadingSwitch="loadingSwitch"
        @updateModelNode="updateModelNode"
      ></GXModelView>
      <GisView v-else-if="isLoadGIS"> </GisView>
      <ModelView
        v-else
        loadModelType="sceneId"
        :sourceId="moduleRelationSceneId"
        :modelTreeProp="customProps.modelTreeProp"
        :cloudRender="cloudRender"
        :collisionReload="collisionReload"
        :moveVisualAngleFlag="moveVisualAngleFlag"
        :modelEngineTransform="modelEngineTransform"
        @sendPlayer="sendPlayer"
        @loadModelEnd="loadModelEnd"
        @setSceneOptions="setSceneOptions"
        @loadingSwitch="loadingSwitch"
        :modelWidth="modelWidth"
        @updateModelNode="updateModelNode"
        @animationEnd="animationEnd"
      ></ModelView>
      <!-- 右键菜单 -->
      <right-click-menu
        v-if="!_.isNil(player) && mode === 'visualization' && !isLoadGIS && isOpenRightMenu"
        :player="player"
        @transferEvent="leftTransferEvent"
      ></right-click-menu>
      <component
        v-if="!isPreview && !isGXView"
        :is="visualizationHeaderCom"
        :hiddenSwitchButton="hiddenSwitchButton"
        :previewSchemeId="previewSchemeId"
        :previewLogo="previewLogo"
        :showIf="showIf"
        :loadModelStatus="customProps.loadModelStatus || isLoadGIS"
        @changeModule="changeModule"
        :defaultSection="defaultSection"
        :alarmJumpSection="alarmJumpSection"
        class="z-11"
        :isSubTenantCheck="isSubTenantCheck"
        @toggleMode="toggleMode"
        @openAlarmList="alarmListVisible = true"
      ></component>
      <BasicTab
        :tabList="basicFunctionList"
        v-show="mode === 'visualization' && !isLoadGIS"
        @tabsClick="tabsClick(arguments, 'basic')"
        :selectTagList="activeBasicList"
        :activeTag="activeBasic"
      ></BasicTab>
      <!-- 左侧业务菜单列表 -->
      <BusinessTab
        position="left"
        :tabList="businessLeftTabList"
        :selectTab="[leftSelectTab, rightSelectTab]"
        :jumpFunction="jumpFunction"
        @tabsClick="tabsClick(arguments, 'business')"
        class="z-11"
        v-show="mode === 'visualization' && !isLoadGIS"
      ></BusinessTab>
      <!-- 右侧业务菜单列表 -->
      <BusinessTab
        v-if="visualizationConfig.showRightPanel"
        position="right"
        :tabList="businessRightTabList"
        :selectTab="[leftSelectTab, rightSelectTab]"
        :jumpFunction="jumpFunction"
        @tabsClick="tabsClick(arguments, 'business')"
        class="z-11"
        v-show="mode === 'visualization' && !isLoadGIS"
      ></BusinessTab>
      <visualization-function-list
        v-if="showFunctionLabels && !isLoadGIS"
        v-show="mode === 'visualization'"
        class="absolute z-12"
        :player="player"
        :class="leftBaseProps.currentComponent.code && !collapsePanel ? 'left-470px' : 'left-90px'"
        :lableDtos="lableDtos"
        :defaultLableDtos="defaultLableDtos"
        :openLableList="businessTabConfigs"
        :noticeCloseComponent="noticeCloseComponent"
        :sourceId="moduleRelationSceneId"
        :cloudRender="cloudRender"
        :collapseLabels="collapsePanel"
        @updateLabel="updateLabel(arguments)"
        @closeTrajectory="trajectoryVisible = false"
      ></visualization-function-list>
      <!-- 左侧容器组件 -->
      <ComponentContainer
        :style="{
          left: collapsePanel ? '-400px' : _.isEmpty(businessLeftTabList) ? '20px' : '100px',
        }"
        key="leftContainer"
        v-if="leftBaseProps.currentComponent.code"
        v-show="mode === 'visualization' && !isLoadGIS"
        :player="player"
        :modelLoadEnd="modelLoadEnd"
        :baseProps="leftBaseProps"
        :customProps="customProps"
        :noticeCloseComponent="noticeCloseComponent"
        :noticeCloseLabel="noticeCloseLabel"
        :transferProps="leftTransferProps"
        :cloudRender="cloudRender"
        :labelList="labelList"
        :sourceId="moduleRelationSceneId"
        :showDocumentDialog="showDocumentDialog"
        :modelNode="modelNode"
        :onlineTagList="onlineTagList"
        :allLineList="allLineList"
        :mode="mode"
        :modelDetail="modelDetail"
        :CrossSectionShow="CrossSectionChart.isShowDialog"
        :currentNode="currentNode"
        :deviceInfo="deviceInfo"
        :zIndexClassName="'z-998'"
        @transferEvent="leftTransferEvent"
        @closeComponent="leftCloseComponent"
        @selectTab="changeLeftSelectTab"
        @operateTrajectory="operateTrajectory"
        @loadingSwitch="loadingSwitch"
        @changeModel="changeModel"
        @collisionReload="collisionReloadHandler"
        @progressReload="progressHandler"
        @updateDeviceInfo="updateDeviceInfo"
      ></ComponentContainer>
      <!-- 右侧容器组件 -->
      <ComponentContainer
        :style="{
          right: collapsePanel
            ? '-400px'
            : _.isEmpty(businessRightTabList) || !visualizationConfig.showRightPanel
            ? '20px'
            : '100px',
        }"
        key="rightContainer"
        v-if="rightBaseProps.currentComponent.code"
        v-show="mode === 'visualization' && !isLoadGIS"
        :player="player"
        :baseProps="rightBaseProps"
        :customProps="customProps"
        :noticeCloseComponent="noticeCloseComponent"
        :noticeCloseLabel="noticeCloseLabel"
        :transferProps="rightTransferProps"
        :cloudRender="cloudRender"
        :labelList="labelList"
        :sourceId="moduleRelationSceneId"
        :showObjInfoDialog="showObjInfoDialog"
        :onlineTagList="onlineTagList"
        :allLineList="allLineList"
        :materialObj="materialObj"
        :mode="mode"
        :zIndexClassName="'z-997'"
        :collapsePanel="collapsePanel"
        @transferEvent="rightTransferEvent"
        @closeComponent="rightCloseComponent"
        @selectTab="changeRightSelectTab"
        @showVideoWall="videoWallVisible = !videoWallVisible"
        @operateTrajectory="operateTrajectory"
      ></ComponentContainer>
      <!-- 全屏组件 -->
      <FullScreenContainer
        :style="{ left: collapsePanel ? '-1980px' : '75px' }"
        key="fullScreenContainer"
        :player="player"
        :baseProps="fullScreenBaseProps"
        v-if="fullScreenBaseProps.currentComponent.code"
        :customProps="customProps"
        :noticeCloseComponent="noticeCloseComponent"
        :noticeCloseLabel="noticeCloseLabel"
        :transferProps="fullScreenTransferProps"
        :cloudRender="cloudRender"
        :labelList="labelList"
        :sourceId="moduleRelationSceneId"
        @transferEvent="fullScreenTransferEvent"
        @closeComponent="fullScreenCloseComponent"
      ></FullScreenContainer>
      <!-- 屏幕闪烁组件 -->
      <AlarmFlicker
        v-if="openAlarmFlicker"
        :frequency="alarmFlickerFrequency"
        :isFlicker="openAlarmFlicker"
      ></AlarmFlicker>
      <AlarmNotification
        v-show="alarmNotificationNum && mode === 'visualization' && !isLoadGIS"
        @alarmJump="alarmJump(arguments)"
        @getAlarmNum="(num) => (alarmNotificationNum = num)"
      ></AlarmNotification>
      <ObjectInfo
        v-if="modelWidth === 1 / 2"
        :width="objInfoWidth"
        :height="objInfoHeight"
        top="100px"
        right="0px"
        @closeObjInfo="closeObjInfo"
        @exitScreen="exitScreen"
        type="screen"
        :dialogForm="objInfoMsg"
        :player="player"
        :module="moduleType"
        :standardId="standardId"
      ></ObjectInfo>
      <!-- 电视墙 -->
      <VideoWall
        class="absolute left-22/100 right-22/100 bottom-36/100 top-0/100 z-20"
        @close="videoWallVisible = false"
        v-if="videoWallVisible"
        :videoWallVisible="videoWallVisible"
      />
      <trajectory
        v-if="trajectoryVisible"
        :cloudRender="cloudRender"
        @closeTrajectory="trajectoryVisible = false"
        @loadHistoryTrialEnd="loadHistoryTrialEnd"
        :personnelId="trajectoryProps.personnelId"
        :tagCode="trajectoryProps.tagCode"
        :modelId="moduleRelationSceneId"
        :cancelFollowAble="false"
      ></trajectory>
      <!-- 宇视云台 -->
      <CameraPicture
        :deviceCode="cameraPictureTarget.deviceCode"
        :plid="cameraPictureTarget.plid"
        @refresh="refresh"
        v-if="cameraPictureTarget.isShowDialog"
        class="w-970px h-500px"
      ></CameraPicture>
      <!-- 摄像头三维标签弹窗 -->
      <videoDialog
        v-if="videoDialogTarget.isShowDialog"
        :show.sync="videoDialogTarget.isShowDialog"
        :code="videoDialogTarget.code"
        :name="videoDialogTarget.name"
        :pIid="videoDialogTarget.pIid"
        :showControlPanel="true"
        :manufacturerCode="videoDialogTarget.manufacturerCode"
        :daHuaParams="videoDialogTarget"
      ></videoDialog>
      <!-- 广西石化定制功能 start -->
      <!-- 阀门 -->
      <ValveDetail
        :currentValve="currentValve"
        @closeGxDetail="closeGxDetail"
        class="w-970px h-500px"
        v-if="currentValve.isShowDialog"
      ></ValveDetail>
      <!-- 盲板 -->
      <BlindPlateDetail
        :currentBlindPlate="currentBlindPlate"
        @closeGxDetail="closeGxDetail"
        class="w-970px h-500px"
        v-if="currentBlindPlate.isShowDialog"
      ></BlindPlateDetail>
      <!-- 三查四定 -->
      <ChecksAndSetsDetail
        :currentChecksAndSets="currentChecksAndSets"
        @closeGxDetail="closeGxDetail"
        class="w-970px h-550px"
        v-if="currentChecksAndSets.isShowDialog"
      ></ChecksAndSetsDetail>
      <CrossSectionChart
        :CrossSectionChart="CrossSectionChart"
        @closeGxDetail="closeGxDetail"
        class="w-790px h-490px"
        v-show="CrossSectionChart.isShowDialog"
        v-if="crossStatus"
      ></CrossSectionChart>
      <CollisionEditPage
        :collisionDetail="collisionDetail"
        @closeCollisionEdit="closeCollisionEdit"
        class="w-970px h-530px"
        v-if="collisionEditShow"
      ></CollisionEditPage>
      <!-- 切换装置loading动画 -->
      <div class="w-full h-full absolute top-0 left-0 z-999 bg-[#00000042]" v-if="animationLoading">
        <div
          class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 flex flex-col items-center"
        >
          <div class="loading-action w-58px h-58px"></div>
          <span class="mt-10px text-16px font-semibold text-[#fff]">{{ loadingTitle }}</span>
        </div>
      </div>
      <!-- 广西石化定制功能 start -->
    </div>
    <div class="w-1/2" v-if="isPreview && isSplitScreen">
      <SplitScreen
        @closeObjectFileSplit="closeObjectFileSplit"
        :dialogForm="objInfoMsg"
        :player="player"
        :standardId="standardId"
      ></SplitScreen>
    </div>
    <!-- 层级高的部分组件 -->
    <AlarmCenter
      v-if="alarmListVisible"
      :visible.sync="alarmListVisible"
      @alarmJump="alarmJump(arguments)"
    ></AlarmCenter>
    <!-- 全局设备面板 -->
    <DevicePanel
      :player="player"
      :mode="mode"
      v-if="devicePanelControlEnabled && modelLoadEnd"
      @transferEvent="leftTransferEvent"
    ></DevicePanel>
  </div>
</template>
<script>
import {
  SectionApi,
  FunctionInfoApi,
  ModelGenericConfigurationApi,
} from '@wiz-api/cloud-render-management'
import { SectionApi as HuizhouSectionApi } from '@wiz-api/huizhou2'
import { ModelApi } from '@wiz-api/material-management'
import { ClipApi } from '@wiz-api/scene-management'
import { DataCategoryApi } from '@wiz-api/data-category-management'
import { instance as cloudRender } from 'wiz-cloud-render'
import EventBusHz from '@/assets/js/EventBus'
import { initActiveBasicTab, destroyCloseBasicTab } from '../assets/js/model/commonMethods'
import ModelView from '../components/model/ModelView'
import GisView from '../components/model/GisView'
import ModelPreview from '../components/model/ModelPreview'
import GXModelView from '../components/model/GXModelView'
import CockpitHeader from '../components/tool/CockpitHeader'
import CockpitHeaderDj from '../components/tool/CockpitHeaderDj'
import CockpitHeaderDyw from '../components/tool/CockpitHeaderDyw'
import BusinessTab from '../components/tool/BusinessTab'
import BasicTab from '../components/tool/BaiscTab'
import VisualizationFunctionList from '../components/tool/VisualizationFunctionList'
import setModelVisible from '../assets/js/model/modelTree'
import { filterPosOutBoxs, filterPosInBox, isInBoxList } from '../assets/js/model/floorShow'
import EventBus from '../assets/js/componentMethods/EventBus'

const clipApi = new ClipApi()
const modelApi = new ModelApi()
const modelGenericConfigurationApi = new ModelGenericConfigurationApi()
const dataCategoryApi = new DataCategoryApi()
const sectionApi = new SectionApi()
const huizhouSectionApi = new HuizhouSectionApi()
const functionInfoApi = new FunctionInfoApi()
const VideoWall = () => {
  return import('../components/business/components/video/YSPlayer/VideoWall')
}
const ComponentContainer = () => {
  return import('../components/tool/ComponentContainer')
}
const AlarmFlicker = () => {
  return import('../components/tool/AlarmFlicker')
}
const FullScreenContainer = () => {
  return import('../components/tool/FullScreenContainer')
}
// 报警消息中心
const AlarmCenter = () => {
  return import('../components/tool/AlarmCenter')
}

// 报警通知
const AlarmNotification = () => {
  return import('../components/tool/AlarmNotification')
}
// 对象信息
const ObjectInfo = () => {
  return import('../components/business/ObjectInfo/objDialog')
}
// 对象信息-分屏
const SplitScreen = () => {
  return import('../components/business/ObjectInfo/splitScreen')
}

// 历史轨迹
const trajectory = () => {
  return import('../components/business/components/trajectory')
}

const CameraPicture = () => {
  return import('../components/business/components/smartSecurity/cameraPicture')
}
const VideoDialog = () => {
  return import('../components/business/components/video/videoDialog')
}

// 阀门详情弹窗
const ValveDetail = () => {
  return import('../components/business/ValveManagement/components/ValveDetail')
}

// 盲板详情弹窗
const BlindPlateDetail = () => {
  return import('../components/business/BlindPlateExhibition/BlindPlateDetail')
}

// 问题详情弹窗
const ChecksAndSetsDetail = () => {
  return import('../components/business/ChecksAndSets/ChecksAndSetsDetail')
}

// 断面图表弹窗
const CrossSectionChart = () => {
  return import('../components/business/CrossSectionAnalysis/ChartWrap')
}
// 右键菜单
const rightClickMenu = () => {
  return import('../components/basic/RightClickMenu')
}
// 问题详情弹窗
const CollisionEditPage = () => {
  return import('../components/business/CollisionCheck/CollisionEditPage')
}
// 设备面板
const DevicePanel = () => {
  return import('../components/business/DevicePanel')
}
export default {
  name: 'VisualizationCockpit',
  props: {
    mode: {
      type: String,
      default: 'visualization',
    },
    modelEngineTransform: {
      type: String,
      default: 'scale(1, 1)',
    },
    showIf: {
      type: Boolean,
      default: true,
    },
    isSubTenantCheck: {
      type: Boolean,
      default: false,
    },
    isLoadGIS: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    ModelView,
    rightClickMenu,
    CockpitHeader,
    BusinessTab,
    ComponentContainer,
    VisualizationFunctionList,
    BasicTab,
    AlarmFlicker,
    FullScreenContainer,
    AlarmCenter,
    AlarmNotification,
    ObjectInfo,
    SplitScreen,
    VideoWall,
    GisView,
    ModelPreview,
    GXModelView,
    trajectory,
    CameraPicture,
    VideoDialog,
    ValveDetail,
    BlindPlateDetail,
    ChecksAndSetsDetail,
    CrossSectionChart,
    CockpitHeaderDyw,
    CockpitHeaderDj,
    CollisionEditPage,
    DevicePanel,
  },
  data() {
    return {
      isPreview: false, // 是否是模型预览（从模型管理过来）
      isSplitScreen: false,
      previewSchemeId: null, // 方案预览id
      previewLogo: null, // 方案预览logoid
      videoWallVisible: false,
      // 广西石化定制参数 start
      isGXView: false,
      GXRunPlayer: false,
      animationLoading: false, // 动画状态
      loadingTitle: null, // 动画名称
      currentValve: {
        // 阀门详情信息
        isShowDialog: false,
      },
      currentBlindPlate: {
        // 盲板详情信息
        isShowDialog: false,
      },
      currentChecksAndSets: {
        // 问题详情信息
        isShowDialog: false,
      },
      CrossSectionChart: {
        // 断面图表
        isShowDialog: false,
      },
      crossStatus: false, // 断面打开状态
      deviceInfo: {
        // 装置的信息，用于存储已切换的装置
        deviceName: null,
        deviceId: null,
        modelId: null,
      },
      gxCustomFunction: [
        'ChecksAndSets',
        'BlindPlateExhibition',
        'CrossSectionAnalysis',
        'MaterialStatistics',
        'AnticorrosionAndInsulation',
        'ValveManagement',
        'PipeExtraction',
        'PipeFlowAnalysis',
      ],
      // 广西石化定制参数 end
      collisionEditShow: false, // 碰撞编辑
      collisionDetail: {}, // 碰撞详情
      collisionReload: false,
      locationType: 5,
      loadModelNode: false, // 针对广西流向功能，使用Node加载
      openAlarmFlicker: false, // 控制报警闪烁
      alarmFlickerFrequency: 500, // 报警闪烁频率
      currentNode: null,
      materialObj: {},
      collapsePanel: false,
      style: {
        width: 1920,
        height: 1080,
        transform: 'scale(1)',
      },
      // 当前选中的模块
      currentModule: '',
      // 左侧业务tab
      businessLeftTabList: [],
      // 右侧业务tab
      businessRightTabList: [],
      // 业务功能的编码集合
      businessFunctionCodes: '',
      // 基础tab
      basicFunctionList: [],
      // 当前板块所包含的所有标签
      lableDtos: [],
      // 默认激活的标签
      defaultLableDtos: [],
      // 激活的基础功能列表
      activeBasicList: [],
      // 当前激活的功能
      activeBasic: '',
      // 左侧容器传递数据
      leftTransferProps: {},
      // 右侧容器传递数据
      rightTransferProps: {},
      // 全屏容器传递数据
      fullScreenTransferProps: {},
      // 通知关闭组件
      noticeCloseComponent: {},
      // 通知关闭的标签数组
      noticeCloseLabel: [],
      player: null,
      leftSelectTab: '', // 当前激活组件
      rightSelectTab: '', // 当前激活组件
      businessTabConfigs: [], // 业务功能可视化配置
      activeComponentList: [],
      defaultSection: '', // 默认打开的板块
      showHidenCodeList: [
        'system.ToolHideModelSpaceSwap',
        'system.ToolHideModel',
        'system.ToolShowModel',
        'system.ToolShowAll',
        'system.ToolShowSingle',
      ],
      leftBaseProps: {
        location: 'left',
        currentComponent: {},
        coexistenceNum: 3,
      },
      rightBaseProps: {
        location: 'right',
        currentComponent: {},
        coexistenceNum: 3,
      },
      fullScreenBaseProps: {
        location: 'fullSrceen',
        currentComponent: {},
        coexistenceNum: 1,
      },
      customProps: {
        // 模型树相关
        modelTreeProp: {
          currentNodeItem: 0, // 当前激活的node
          currentNodeName: '', // 点选时当前激活的节点名称
          treeData: [], // 模型树数据
          defaultCheckedKey: [], // 模型树选中的节点
          filterItem: [], // 模型树不需要显示的节点及他的父节点列表
          modelHideList: [], // 模型隐藏队列
          modelTreeLoadEnd: false, // 模型树数据加载完毕
          spaceSwapStatus: false, // 交换空间状态
        },
        sceneId: '',
        loadModelStatus: false,
        mode: 'visualization',
      },
      moduleRelationSceneId: '',
      labelList: [],
      openComTypes: ['basic', 'business', 'mainComponent', 'tags', 'openComponent'],
      showFunctionLabels: false,
      alarmListVisible: false, // 报警消息中心弹框显隐
      alarmJumpSection: {}, // 点击报警消息跳转的板块
      jumpFunction: { code: '' }, // 跳转的功能板块
      isJumpSectionOver: true, // 是否跳转板块完成
      recordCode: '', // 用于记录需要跳转的功能的code
      alarmNotificationNum: 0, // 报警通知的数量
      modelWidth: 1, // 模型宽度
      objInfoWidth: '',
      objInfoHeight: '',
      showObjInfoDialog: false,
      modelDetail: {
        // 模型预览/广西定制功能使用
        filePath: '',
        materialFileId: '',
        modelFileId: '',
      },
      objInfoMsg: {}, // 对象信息的数据
      showDocumentDialog: false,
      moduleType: '',
      moveVisualAngleFlag: false, // 切到初始视角的标识
      modelNode: {}, // 点选模型，获取模型的节点node
      // 当前在线人员的标签列表
      onlineTagList: [],
      // 当前在线人员的标签列表全部信息
      allLineList: [],
      // 历史轨迹组件
      trajectoryVisible: false,
      trajectoryProps: {
        personnelId: '',
      },
      cameraPictureTarget: {
        isShowDialog: false,
        deviceCode: '',
        plid: '',
      },
      videoDialogTarget: {
        isShowDialog: false,
        code: '',
        name: '',
        pIid: '',
        manufacturerCode: '',
        id: '',
      },
      standardId: '',
      visualizationLableDtos: [],
      visualizationDefaultLableDtos: [],
      cockpitLableDtos: [],
      cockpitDefaultLableDtos: [],
      isOpenDeaultComponent: false, // 是否打开默认组件
      modelLoadEnd: false, // 模型是否加载完毕
      // 获取建筑范围值列表
      buildingRangeList: [],
      floorTagInterval: null,
    }
  },
  computed: {
    // 隐藏驾驶舱/可视化切换按钮
    hiddenSwitchButton() {
      return this.$route.name === 'visualizationCockpitIndex'
    },
    // 左侧遮罩样式
    visualizationLeftClass() {
      return this.leftBaseProps.currentComponent.code && !this.collapsePanel
        ? 'left-wide-mask w-269px'
        : 'left-narrow-mask w-90px'
    },
    // 右侧遮罩样式
    visualizationRightClass() {
      if (this.rightBaseProps.currentComponent.code && !this.collapsePanel) {
        return 'right-wide-mask w-269px'
      }
      if (this.visualizationConfig.showRightPanel && !_.isEmpty(this.businessRightTabList)) {
        return 'right-narrow-mask w-90px'
      }
      return ''
    },
    // 显示左侧遮罩
    showLeftMask() {
      return (
        (!_.isEmpty(this.businessLeftTabList) || this.leftBaseProps.currentComponent.code) &&
        this.mode === 'visualization'
      )
    },
    // 显示右侧遮罩
    showRightMask() {
      return (
        ((this.visualizationConfig.showRightPanel && !_.isEmpty(this.businessRightTabList)) ||
          this.rightBaseProps.currentComponent.code) &&
        this.mode === 'visualization'
      )
    },
    // 显示收起/展开按钮
    showControlPanel() {
      return (
        this.leftBaseProps.currentComponent.code ||
        this.rightBaseProps.currentComponent.code ||
        this.fullScreenBaseProps.currentComponent.code
      )
    },
    // 广西石化全场模型名称
    gxBaseModelName() {
      return Wiz.globalSettings.globalConfig?.gxBaseModelName || ''
    },
    // 可视化相关配置
    visualizationConfig() {
      return Wiz.globalSettings.globalConfig?.visualizationConfig || {}
    },
    currentTheme() {
      return (
        _.get(Wiz, 'globalSettings.dynamicModules.modules["visualization-cockpit"].config')
          ?.currentTheme || 'default'
      )
    },
    // 模型相关设置
    modelSetting() {
      return (
        Wiz.globalSettings.globalConfig?.modelSetting ||
        _.get(Wiz, 'globalSettings.dynamicModules.modules["visualization-cockpit"].config')
          ?.modelSetting ||
        {}
      )
    },
    // 是否开启模型右键功能
    isOpenRightMenu() {
      return (
        _.get(Wiz, 'globalSettings.dynamicModules.modules["visualization-cockpit"].config')
          ?.isOpenRightMenu || false
      )
    },
    // 设备面板开关配置
    devicePanelControlEnabled() {
      const devicePanelConfig =
        Wiz.globalSettings.globalConfig?.visualizationConfig?.devicePanel || {}
      return devicePanelConfig.devicePanelControlEnabled
    },
    // 模型文件
    modelFileList() {
      return this.modelSetting.modelFileList || []
    },
    cloudRender() {
      return cloudRender
    },
    metalBIMmodelId() {
      return (
        _.get(Wiz, 'globalSettings.dynamicModules.modules["visualization-cockpit"].config')
          ?.metalBIMmodelId || '3a0f7d35-e1b4-b198-322d-e2590b6d8528'
      )
    },
    // 可视化头部组件
    visualizationHeaderCom() {
      return (
        _.get(Wiz, 'globalSettings.dynamicModules.modules["visualization-cockpit"].config')
          ?.headerComponentCode || 'CockpitHeader'
      )
    },
    visualizationCockpitConfig() {
      return _.get(Wiz, 'globalSettings.dynamicModules.modules["visualization-cockpit"].config')
    },
  },
  async created() {
    this.getDataCategory()
    if (this.$route.query.schemeId) {
      // 从方案管理点击预览
      this.previewSchemeId = this.$route.query.schemeId
      this.previewLogo = this.$route.query.logo
    } else if (this.$route.query.modelInfoId) {
      // 模型预览
      const modelInfoType = this.$route.query.modelInfoType ? this.$route.query.modelInfoType : 'pr'
      this.modelDetail = Object.assign(this.modelDetail, {
        filePath: `data://../apps/${this.modelSetting.folderName}/models/${this.$route.query.modelInfoId}/${this.$route.query.modelInfoId}.${modelInfoType}`,
        materialFileId: this.$route.query.textureInfoId,
        modelFileId: this.$route.query.modelInfoId,
      })
      this.isPreview = true
      this.getFunctionTabInfo()
    } else if (this.$route.query.proj && this.$route.query.proj === 'gx') {
      // if (this.$route.query.name === 'PipeFlowAnalysis') {
      //   this.loadModelNode = true // 针对液位单独使用node加载，方便加动画
      // }
      this.isGXView = true
      this.getBaseModelInfo()
      this.getGxFunctionInfo(this.$route.query.name)
    }
  },
  mounted() {
    window.addEventListener('openComponent', (e) => {
      const findComponent = _.find(this.activeComponentList, ['code', e.detail.toCom?.origin]) || {}
      switch (findComponent.locationType) {
        case 1:
          if (this.openComTypes.includes(e.detail.type)) {
            this.leftBaseProps.currentComponent = _.cloneDeep(e.detail.toCom)
          }
          this.$set(this.leftTransferProps, e.detail.toCom.code, _.cloneDeep(e.detail.props))
          break
        case 3:
          // 全屏
          if (this.openComTypes.includes(e.detail.type)) {
            this.fullScreenBaseProps.currentComponent = _.cloneDeep(e.detail.toCom)
          }
          this.$set(this.fullScreenTransferProps, e.detail.toCom.code, _.cloneDeep(e.detail.props))
          break
        case 2:
        default:
          if (e.detail.position && e.detail.position === 'left') {
            // 针对单独想打开左侧已有功能
            if (this.openComTypes.includes(e.detail.type)) {
              this.leftBaseProps.currentComponent = _.cloneDeep(e.detail.toCom)
            }
            this.$set(this.leftTransferProps, e.detail.toCom.code, _.cloneDeep(e.detail.props))
          } else {
            // 默认展示在右侧
            if (this.openComTypes.includes(e.detail.type)) {
              this.rightBaseProps.currentComponent = _.cloneDeep(e.detail.toCom)
            }
            this.$set(this.rightTransferProps, e.detail.toCom.code, _.cloneDeep(e.detail.props))
          }
          break
      }
    })
    this.setScale()
    window.onresize = _.debounce(this.setScale, 500)
    window.addEventListener('getOnlineTagList', this.getOnlineTagListHandler)
    window.addEventListener('setOnlinePositionList', this.setPositionListHandler)
    window.addEventListener('openYSCameraControl', this.openYSCameraControl)
    window.addEventListener('openVideoDialog', this.openVideoDialog)
    window.addEventListener('gxDialogControl', this.gxDialogControl)
    window.addEventListener('openCollisionEdit', this.openCollisionEdit)
    // 设置定时执行
    // this.floorTagInterval = setInterval(() => {
    //   this.isFloorTag()
    // }, 1000)
  },
  watch: {
    'leftBaseProps.currentComponent': {
      handler(val) {
        if (!val.code && !this.rightBaseProps.currentComponent.code) {
          this.collapsePanel = false
        }
      },
      deep: true,
    },
    'rightBaseProps.currentComponent': {
      handler(val) {
        if (!val.code && !this.leftBaseProps.currentComponent.code) {
          this.collapsePanel = false
        }
      },
      deep: true,
    },
    'fullScreenBaseProps.currentComponent': {
      handler(val) {
        if (!val.code && !this.fullScreenBaseProps.currentComponent.code) {
          this.collapsePanel = false
        }
      },
      deep: true,
    },
    mode(value) {
      if (value === 'cockpit') {
        this.collapsePanel = true
        this.moveVisualAngleFlag = !this.moveVisualAngleFlag
      } else {
        this.collapsePanel = false
      }
      this.customProps.mode = value
      this.lableDtos = value === 'cockpit' ? this.cockpitLableDtos : this.visualizationLableDtos
      this.defaultLableDtos =
        value === 'cockpit' ? this.cockpitDefaultLableDtos : this.visualizationDefaultLableDtos
    },
  },
  methods: {
    // 判断标签是否在楼层里
    async isFloorTag() {
      if (this.buildingRangeList.length === 0) {
        const allArea = []
        const [err, res] = await clipApi.getList({
          sceneId: this.moduleRelationSceneId,
        })
        if (!err) {
          res.items.forEach((item) => {
            if (item.maximumLocation && item.minimumLocation) {
              const maxPosition = JSON.parse(item.maximumLocation)
              const max = [maxPosition.x, maxPosition.y, maxPosition.z]
              const minPosition = JSON.parse(item.minimumLocation)
              const min = [minPosition.x, minPosition.y, minPosition.z]
              allArea.push([max, min])
            }
          })
        }
        this.buildingRangeList = allArea
      }
      if (this.player?.Native?.Camera) {
        // 获取相机当前位置, 并且判断当前是否在box里面
        const CamP = await this.player.Native.Camera.currentParam()
        const isInBox = isInBoxList(CamP.eye, this.buildingRangeList)
        // 获取所有marker
        const markerList = await this.player.Native.GisMarker.getMarkerList()
        if (isInBox.in) {
          // 如果在某个box里面
          const updateMarkerList = filterPosInBox(markerList, isInBox.box)
          this.player.Native.GisMarker.batchUpdate(updateMarkerList)
        } else {
          // 不在box里面
          const updateMarkerList = filterPosOutBoxs(markerList, this.buildingRangeList)
          this.player.Native.GisMarker.batchUpdate(updateMarkerList)
          console.log(updateMarkerList)
        }
      }
    },
    // 宇视摄像头关闭
    refresh() {
      this.cameraPictureTarget.isShowDialog = false
    },
    // 关闭广西定制功能详情弹窗
    closeGxDetail(val) {
      this[val].isShowDialog = false
    },
    // 关闭碰撞检查编辑界面
    closeCollisionEdit() {
      this.collisionEditShow = false
    },
    // 打开碰撞编辑页
    openCollisionEdit(data) {
      console.log('详情', data)
      this.collisionDetail = this.$options.data().collisionDetail
      this.$nextTick(() => {
        this.collisionDetail = data.detail
        this.collisionEditShow = true
      })
    },
    // 打开宇视摄像头
    openYSCameraControl(e) {
      const item = e.detail
      this.cameraPictureTarget = {
        isShowDialog: true,
        deviceCode: item.deviceCode || item.code,
        plid: item.plid || item.pIid,
      }
    },
    // 打开三维监控弹窗
    openVideoDialog(e) {
      const item = e.detail
      this.videoDialogTarget = {
        isShowDialog: true,
        code: item.code || '',
        name: item.name || '',
        manufacturerCode: item.manufacturerCode || 'Hik',
        pIid: item.pIid || '',
        id: item.id || '',
      }
    },
    // 打开详情列表-广西定制
    gxDialogControl(e) {
      const detail = e.detail
      const currentDetail = {
        ...detail,
        isShowDialog: true,
      }
      if (detail.currentDialog && detail.currentDialog === 'valve') {
        // 阀门
        this.currentValve = currentDetail
      } else if (detail.currentDialog && detail.currentDialog === 'blindPlate') {
        // 盲板
        this.currentBlindPlate = currentDetail
      } else if (detail.currentDialog && detail.currentDialog === 'checksAndSets') {
        // 三查四定
        this.currentChecksAndSets = currentDetail
      } else if (detail.currentDialog && detail.currentDialog === 'CrossSectionChart') {
        // 断面分析
        this.CrossSectionChart.isShowDialog = detail.status
        if (detail.type === 'open') {
          this.crossStatus = true
        }
      }
    },
    // 开关动画加载loading(广西石化功能)
    loadingSwitch({ bol, title }) {
      this.animationLoading = bol
      this.loadingTitle = title
    },
    // 切换模型
    changeModel(modelDetail) {
      this.modelDetail = Object.assign(this.modelDetail, modelDetail)
    },
    // 更新装置信息
    updateDeviceInfo(deviceDetail) {
      this.deviceInfo = Object.assign(this.deviceInfo, deviceDetail)
    },
    collisionReloadHandler() {
      // 碰撞功能需要切换加载方式
      if (this.collisionReload) return
      this.modelLoadEnd = false
      console.log('切换回Node加载模型')
      const tempSourceId = this.moduleRelationSceneId
      this.moduleRelationSceneId = 'empty'
      this.collisionReload = true
      setTimeout(() => {
        this.moduleRelationSceneId = tempSourceId
      }, 500)
    },
    progressHandler() {
      // 碰撞功能需要切换回初始加载方式
      if (!this.collisionReload) return
      this.modelLoadEnd = false
      console.log('切换回Model加载模型')
      const tempSourceId = this.moduleRelationSceneId
      this.moduleRelationSceneId = 'empty'
      this.collisionReload = false
      setTimeout(() => {
        this.moduleRelationSceneId = tempSourceId
      }, 500)
    },
    /**
     * @description: 获取功能按钮信息
     * @return {*}
     */
    async getFunctionTabInfo() {
      const [err, res] = await modelGenericConfigurationApi.getList()
      if (!err && res?.items.length) {
        let businessTree = []
        if (res.items[0].extraDto?.businessFunctionTreeList) {
          businessTree = _.filter(res.items[0].extraDto.businessFunctionTreeList, (item) => {
            return !this.gxCustomFunction.includes(item.detail.code)
          })
        }
        this.businessLeftTabList = businessTree
        this.basicFunctionList = res.items[0].extraDto?.basicFunctionTreeList || []
      }
    },
    // 获取模型信息
    async getBaseModelInfo() {
      try {
        const [err, res] = await modelApi.getList({
          directoryId: null,
          name: null,
          skipCount: 0,
          maxResultCount: 99,
        })
        if (!err && res.items.length && this.gxBaseModelName) {
          const modelDetailInfo = _.find(res.items, (item) => {
            return item.name === this.gxBaseModelName
          })
          if (modelDetailInfo) {
            const modelInfo = _.find(modelDetailInfo.medias, ['mediaType', 1])
            const textureInfo = _.find(modelDetailInfo.medias, ['mediaType', 2])
            if (modelInfo?.fileInfoId) {
              this.modelDetail = Object.assign(this.modelDetail, {
                filePath: `data://../apps/${this.modelSetting.folderName}/models/${modelInfo.fileInfoId}/${modelInfo.fileInfoId}.pr`,
                materialFileId: textureInfo ? textureInfo.fileInfoId : '',
                modelFileId: modelInfo.fileInfoId,
              })
            }
          }
        }
        this.GXRunPlayer = true
      } catch (error) {
        console.log('❌ getBaseModelInfo error', error)
        this.GXRunPlayer = true
      }
    },
    /**
     * @description: 获取功能按钮信息
     * @return {*}
     */
    async getGxFunctionInfo(functionCode) {
      const [err, res] = await modelGenericConfigurationApi.getList()
      if (!err && res?.items.length) {
        this.basicFunctionList = res.items[0].extraDto?.basicFunctionTreeList || []
        if (res.items[0].extraDto?.businessFunctionTreeList) {
          let functionList = _.filter(res.items[0].extraDto?.businessFunctionTreeList, (item) => {
            return item.detail.code === 'szh' || item.detail.code === functionCode
          })
          if (functionList) {
            functionList = _.sortBy(functionList, (item) => {
              return item.detail.seqNo
            })
            this.businessLeftTabList.push(...functionList)
          }
        }
      }
    },
    updateModelNode(node) {
      this.modelNode = node
      EventBus.$emit('updateModelNode', node)
    },
    // 关闭分屏
    closeObjInfo() {
      this.modelWidth = 1
    },
    closeObjectFileSplit() {
      this.isSplitScreen = false
    },
    // 退出分屏
    exitScreen(val) {
      this.modelWidth = 1
      if (val === 'objInfo') {
        this.showObjInfoDialog = true
      } else if (val === 'document') {
        this.showDocumentDialog = true
      }
    },
    // 接收场景信息
    setSceneOptions(data) {
      this.$set(this.customProps, 'sceneOptions', data)
    },
    // 标签的改变
    updateLabel([newLabel, oldLabel, isInfloor]) {
      console.log('updateLabel', newLabel, oldLabel, isInfloor)
      this.labelList = _.cloneDeep(newLabel)
      // 除了在楼层中
      const closeList = []
      _.forEach(newLabel, (item) => {
        _.forEach(oldLabel, (it) => {
          if (item.code === it.code && !item.checked && it.checked) {
            // 如果建筑标签被关闭并且当前正在楼层中，则不关闭建筑详情弹框
            if (!isInfloor || item.code !== 'BuildingList') {
              closeList.push(item)
            }
          }
        })
      })
      this.noticeCloseLabel = closeList
    },
    changePanel() {
      this.collapsePanel = !this.collapsePanel
    },
    toggleMode() {
      this.$emit('toggleMode')
      this.rightBaseProps.currentComponent = {}
      this.leftBaseProps.currentComponent = {}
    },
    // 获取放大缩小比例
    getScale() {
      this.style.height =
        window.innerHeight === window.screen.height
          ? 1080
          : 1080 - (window.screen.height - window.innerHeight)
      const w = window.innerWidth / this.style.width
      const h = window.innerHeight / this.style.height
      return `${w},${h}`
    },
    // 设置比例
    setScale() {
      this.style.transform = `scale(${this.getScale()})`
    },
    // 获取数据字典
    async getDataCategory() {
      const [err, res] = await dataCategoryApi.getList({
        keyWord: 'CloudRenderManagement',
        skipCount: 0,
        maxResultCount: 15,
        sorting: 'seqNo asc',
      })
      if (!err && res) {
        const currentCategorie = _.find(res.items, ['code', 'CloudRenderManagement'])
        if (currentCategorie) {
          this.getDataCategoryItems(currentCategorie.id)
        }
      }
    },
    // 获取数据字典项
    async getDataCategoryItems(id) {
      const [err, res] = await dataCategoryApi.get(id)
      if (!err && res) {
        const leftMaxNum = _.find(res.dataItems, ['code', 'leftMaxNum'])
        const rightMaxNum = _.find(res.dataItems, ['code', 'rightMaxNum'])
        const defaultSection = _.find(res.dataItems, ['code', 'defaultSection'])
        this.leftBaseProps.coexistenceNum = Number(leftMaxNum?.data) || 3
        this.rightBaseProps.coexistenceNum = Number(rightMaxNum?.data) || 3
        this.defaultSection = this.$route.query.defaultSection
          ? this.$route.query.defaultSection
          : defaultSection?.data || ''
      }
    },
    // 获取业务功能可视化配置
    async getTabConfigs(id) {
      const [err, res] = await functionInfoApi.get(id)
      if (!err && res) {
        return res.extraDto?.lableDtos
      }
    },
    // 左侧激活的tab
    changeLeftSelectTab(tab) {
      this.leftSelectTab = tab
    },
    // 右侧激活的tab
    changeRightSelectTab(tab) {
      this.rightSelectTab = tab
    },
    // player实例加载完成
    sendPlayer(player) {
      this.player = player
      this.customProps.loadModelStatus = true
    },
    // 模型加载完成
    loadModelEnd(node = null) {
      this.customProps.loadModelStatus = true
      if (this.player) {
        console.log(this.cloudRender, '模型加载完成后云渲染实例')
        this.showFunctionLabels = true
        this.$emit('loadModelEnd')
      }

      this.currentNode = node
      this.openDeaultComponent()
      this.modelLoadEnd = true
    },

    // 进入页面默认打开Sisystem
    openDeaultComponent(param) {
      const query = param || this.$route.query
      if (query.openDeaultComponent === 'SisSystem' && query.id && !this.isOpenDeaultComponent) {
        this.$set(this.leftBaseProps, 'currentComponent', {
          code: 'SisSystem',
          name: '工艺BIM',
          locationType: 1,
          origin: 'business',
        })
        this.$set(this.leftTransferProps, 'SisSystem', {
          id: query.id,
          toDefaultOpen: 'SisSystem',
        })
        this.isOpenDeaultComponent = true
      }
    },
    async tabsClick(arg, type) {
      // 定制化加载模型-start
      // if (arg[0].code === 'MetalBim') {
      //   this.moduleRelationSceneId = this.metalBIMmodelId
      // }
      // 定制化加载模型-end
      this.noticeCloseComponent = {}
      const tabDetail = arg[0]
      if (tabDetail.code === 'typhoon') {
        this.$router.push({
          name: 'preventionHome',
          params: {
            path: this.$routlllle.path,
            defaultSection: this.locationType,
          },
        })
        return
      }
      // jumpAddressConfig配置跳转其他页面，不打开页面组件
      const jumpAddressConfig = this.visualizationCockpitConfig?.jumpAddressConfig || {}
      const url = jumpAddressConfig[tabDetail.code]
      if (url) {
        window.open(url)
        return
      }

      if (type === 'basic') {
        if (_.includes(this.showHidenCodeList, tabDetail.code)) {
          const currentSelectItem = await this.player.Native.ModelTree.getSelectedItem()
          return setModelVisible(
            this.player,
            tabDetail.code,
            true,
            currentSelectItem,
            this.customProps.modelTreeProp
          )
        }
        if (this.activeBasicList.indexOf(tabDetail.code) !== -1) {
          this.activeBasicList.splice(this.activeBasicList.indexOf(tabDetail.code), 1)
          this.activeBasic = ''
          if (tabDetail.locationType === 0) {
            // TODO: 移除
            this.noticeCloseComponent = tabDetail
            // 销毁关闭的基础功能相关设置
            const closeRes = await destroyCloseBasicTab(tabDetail.code, this.player)
            return
          }
          this.noticeCloseComponent = tabDetail
          return
        }
        this.activeBasicList.push(tabDetail.code)
        this.activeBasic = tabDetail.code
        // TODO: 设置功能
        // 激活当前点击基础功能
        const openRes = await initActiveBasicTab(tabDetail.code, this.player, this.activeBasicList)
      }
      // 设置配置
      const configList = await this.getTabConfigs(tabDetail.id)
      this.businessTabConfigs = _.map(configList, (item) => {
        return { id: item.id, code: item.code, name: item.name, origin: tabDetail.code }
      })
      if (tabDetail.locationType === 0) {
        // TODO: 设置功能
        return
      }
      this.activeComponentList.push({
        locationType: tabDetail.locationType,
        code: tabDetail.code,
      })
      // 关闭全屏弹框
      if (
        this.fullScreenBaseProps.currentComponent.code &&
        this.fullScreenBaseProps.currentComponent.code !== tabDetail.code
      ) {
        this.fullScreenCloseComponent(this.fullScreenBaseProps.currentComponent, true)
      }
      switch (tabDetail.locationType) {
        case 0:
          // 默认，不打开弹框
          break
        case 1:
          // 左侧弹框
          this.leftBaseProps.currentComponent = tabDetail
          this.collapsePanel = false
          break
        case 2:
          // 右侧弹框
          this.rightBaseProps.currentComponent = tabDetail
          this.collapsePanel = false
          break
        case 3:
          // 全屏弹框
          this.fullScreenBaseProps.currentComponent = tabDetail
          this.collapsePanel = false
          break
        default:
          break
      }
    },
    async changeModule(moduleItem) {
      this.locationType = moduleItem.functionLocationType
      const sceneId = this.mode === 'cockpit' ? moduleItem.cockpitSceneId : moduleItem.sceneId
      this.customProps.loadModelStatus = this.moduleRelationSceneId === sceneId
      this.moduleRelationSceneId = sceneId
      this.$emit('updateSceneId', sceneId)
      this.customProps.sceneId = sceneId
      await this.getSectionsDetail(moduleItem.id)
      this.rightBaseProps.currentComponent = {}
      this.leftBaseProps.currentComponent = {}
      this.fullScreenBaseProps.currentComponent = {}
      this.rightSelectTab = ''
      this.leftSelectTab = ''
      this.$emit('changeModule', moduleItem)
      if (!this.isJumpSectionOver) {
        this.jumpFunction = { code: _.cloneDeep(this.recordCode) }
        this.isJumpSectionOver = true
      }
    },
    // 点击报警消息跳转
    alarmJump([jumpSection, code]) {
      // 如果需要跳转的板块就是当前的板块，则直接打开功能
      if (this.locationType === jumpSection.functionLocationType) {
        this.jumpFunction = { code: _.cloneDeep(code) }
      } else {
        // 如果不是当前板块，则先跳转到对应板块再打开功能
        this.isJumpSectionOver = false
        // 记录需要跳转功能的code
        this.recordCode = _.cloneDeep(code)
        this.alarmJumpSection = jumpSection
      }
    },
    /**
     * @description: 获取板块的id
     * @param {*} id
     * @return {*}
     */

    async getSectionsDetail(id) {
      const currentApi = this.visualizationConfig.showRightPanel ? huizhouSectionApi : sectionApi
      const [err, res] = await currentApi.get(id)
      if (!err && res) {
        this.businessLeftTabList = res.extraDto?.businessFunctionTreeList || []
        this.businessRightTabList = res.extraDto?.businessFunctionRightTreeList || []
        this.businessFunctionCodes = [
          ..._.map(res.extraDto?.businessFunctionInfoDtos, 'code'),
          ..._.map(res.extraDto?.businessFunctionRightInfoDtos, 'code'),
        ]
        this.basicFunctionList = res.extraDto?.basicFunctionTreeList || []

        this.visualizationLableDtos = res.extraDto?.lableDtos || []
        this.visualizationDefaultLableDtos = res.extraDto?.defaultLableDtos || []
        this.cockpitLableDtos = res.extraDto?.cockpitLableDtos || []
        this.cockpitDefaultLableDtos = res.extraDto?.cockpitDefaultLableDtos || []

        this.lableDtos =
          this.mode === 'cockpit' ? this.cockpitLableDtos : this.visualizationLableDtos
        this.defaultLableDtos =
          this.mode === 'cockpit'
            ? this.cockpitDefaultLableDtos
            : this.visualizationDefaultLableDtos
      }
    },
    // 左侧容器事件触发
    leftTransferEvent(data) {
      console.log('transferEvent-11111', data)
      if (data.toCom.code === 'NewCollisionCheck' && data.props && data.props.materialObj) {
        this.materialObj = data.props.materialObj
      }
      // 移交文档(分屏功能，模型只展示屏幕的一半，另一半展示文档的文件)
      if (data.toCom.code === 'ObjectInfo' && data.props && data.props.width) {
        this.moduleType = 'document'
        this.modelWidth = 1 / 2
        this.objInfoWidth = `${data.props.width}px`
        this.objInfoHeight = `${data.props.height}px`
        this.showDocumentDialog = false
        this.objInfoMsg = data.props.dialogForm
        this.standardId = data.props.standardId
        return
      }
      if (this.openComTypes.includes(data.type)) {
        this.rightBaseProps.currentComponent = _.cloneDeep(data.toCom)
      }
      this.$set(this.rightTransferProps, data.toCom.code, _.cloneDeep(data.props))
      if (data.props?.controlAlarm) {
        // 控制闪烁
        this.openAlarmFlicker = !!data.props?.openAlarmFlicker
      }
      this.alarmFlickerFrequency =
        data.props?.flickerFrequency &&
        _.isNumber(data.props?.flickerFrequency) &&
        _.toNumber(data.props?.flickerFrequency) > 0
          ? data.props?.flickerFrequency
          : 500
    },
    // 右侧容器事件触发
    rightTransferEvent(data) {
      if (data.toCom.code === 'ObjectFileSplit') {
        this.objInfoMsg = data.props.formData
        this.standardId = data.props.standardId
        this.isSplitScreen = false
        this.$nextTick(() => {
          this.isSplitScreen = true
        })
        return
      }
      // 对象信息(分屏功能，模型只展示屏幕的一半，另一半展示对象信息的文件)
      if (data.toCom.code === 'HandoverObject' && data.props.width) {
        this.moduleType = 'objInfo'
        this.modelWidth = 1 / 2
        this.objInfoWidth = `${data.props.width}px`
        this.objInfoHeight = `${data.props.height}px`
        this.showObjInfoDialog = false
        this.objInfoMsg = data.props.dialogForm
        this.standardId = data.props.standardId
        return
      }
      if (this.openComTypes.includes(data.type)) {
        this.leftBaseProps.currentComponent = _.cloneDeep(data.toCom)
      }
      this.$set(this.leftTransferProps, data.toCom.code, _.cloneDeep(data.props))
      if (data.props?.controlAlarm) {
        // 控制闪烁
        this.openAlarmFlicker = !!data.props?.openAlarmFlicker
      }
      this.alarmFlickerFrequency =
        data.props?.alarmFlickerFrequency &&
        _.isNumber(data.props?.alarmFlickerFrequency) &&
        _.toNumber(data.props?.alarmFlickerFrequency) > 0
          ? data.props?.alarmFlickerFrequency
          : 500
    },
    // 全屏容器事件触发
    fullScreenTransferEvent(data) {
      if (this.openComTypes.includes(data.type)) {
        this.fullScreenBaseProps.currentComponent = _.cloneDeep(data.toCom)
      }
      this.$set(this.fullScreenTransferProps, data.toCom.code, _.cloneDeep(data.props))
      if (data.props?.controlAlarm) {
        // 控制闪烁
        this.openAlarmFlicker = !!data.props?.openAlarmFlicker
      }
      this.alarmFlickerFrequency =
        data.props?.alarmFlickerFrequency &&
        _.isNumber(data.props?.alarmFlickerFrequency) &&
        _.toNumber(data.props?.alarmFlickerFrequency) > 0
          ? data.props?.alarmFlickerFrequency
          : 500
    },
    // 左侧组件关闭事件
    leftCloseComponent(val, isEmpty) {
      if (val.code === 'CrossSectionAnalysis') {
        this.CrossSectionChart.isShowDialog = false
        this.crossStatus = false
      }
      // 定制化加载模型-start
      // if (val.code === 'MetalBim') {
      //   this.moduleRelationSceneId = this.customProps.sceneId
      // }
      // 定制化加载模型-end
      this.noticeCloseComponent = val
      if (isEmpty) {
        this.leftBaseProps.currentComponent = {}
        this.leftTransferProps = {}
      }
      this.cancelBasicStatus(val)
    },
    // 右侧组件关闭事件
    rightCloseComponent(val, isEmpty) {
      this.noticeCloseComponent = val
      if (isEmpty) {
        this.rightBaseProps.currentComponent = {}
        this.rightTransferProps = {}
      }
      this.cancelBasicStatus(val)
    },
    // 全屏组件关闭事件
    fullScreenCloseComponent(val, isEmpty) {
      this.noticeCloseComponent = val
      if (isEmpty) {
        this.fullScreenBaseProps.currentComponent = {}
        this.fullScreenTransferProps = {}
      }
      this.cancelBasicStatus(val)
    },
    cancelBasicStatus(val) {
      if (this.activeBasicList.includes(val.code)) {
        this.activeBasicList.splice(this.activeBasicList.indexOf(val.code), 1)
        this.activeBasic = ''
      }
    },
    // 获取当前在线人员列表
    getOnlineTagListHandler(e) {
      this.onlineTagList = e?.detail?.onlineTagList
      if (!_.isEmpty(e?.detail?.allLineList)) {
        this.allLineList = e?.detail?.allLineList
      }
    },
    // 监听位置更新事件，同步更新allLineList中的位置信息
    setPositionListHandler(e) {
      const positionList = e.detail?.position || []
      if (!positionList.length) return

      // 更新onlineTagList中的位置信息
      // if (this.onlineTagList && this.onlineTagList.length) {
      //   this.onlineTagList = this.onlineTagList.map((person) => {
      //     const positionItem = _.find(positionList, ['tagId', person.tagId])
      //     if (positionItem) {
      //       return {
      //         ...person,
      //         x: positionItem.x,
      //         y: positionItem.y,
      //         z: positionItem.z,
      //       }
      //     }
      //     return person
      //   })
      // }

      // 更新allLineList中的位置信息
      if (this.allLineList && this.allLineList.length) {
        this.allLineList = this.allLineList.map((item) => {
          const positionItem = _.find(positionList, ['tagId', item.tagId])
          if (positionItem) {
            return {
              ...item,
              x: positionItem.x,
              y: positionItem.y,
              z: positionItem.z,
            }
          }
          return item
        })
      }
    },
    // 操作历史轨迹
    operateTrajectory({ visible, personnelId, tagCode }) {
      this.trajectoryVisible = visible
      this.trajectoryProps.personnelId = personnelId
      this.trajectoryProps.tagCode = tagCode
    },
    // 历史轨迹加载完成
    loadHistoryTrialEnd() {
      const trajectoryEndEvent = new CustomEvent('loadHistoryTrialEnd')
      window.dispatchEvent(trajectoryEndEvent)
    },
    openDialog(params) {
      if (!_.includes(this.businessFunctionCodes, params?.code)) {
        if (params?.code === 'EmergencyDisposal') {
          return this.$message.warning({
            showClose: true,
            message: '当前板块没有配置应急一张图功能',
          })
        }
        if (params?.code === 'OperationSafetyPage') {
          return this.$message.warning({
            showClose: true,
            message: '当前板块没有配置作业一张图功能',
          })
        }
      }
      this.jumpFunction = params
    },
    // 地球动画结束（因为定时器实现，这是大概时间，不能作为准确时间去使用）
    animationEnd(data) {
      this.$emit('animationEnd', data)
    },
  },
  beforeDestroy() {
    clearInterval(this.floorTagInterval)
    window.removeEventListener('getOnlineTagList', this.getOnlineTagListHandler)
    window.removeEventListener('setOnlinePositionList', this.setPositionListHandler)
    localStorage.removeItem('currentModelNodeCode')
    if (this.player) {
      this.cloudRender.Engine.destroyEngine()
    }
  },
}
</script>
<style lang="scss">
@import '@/assets/css/popover';
@import '../../../assets/css/cyan';
</style>
<style lang="scss" scoped>
@import '@/assets/css/index';

.control-panel {
  background-image: url('../assets/images/control/collapse.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.unfold {
  transform: rotateZ(180deg);
}

.collapse {
  transform: rotateZ(0deg);
}

.visualization-cockpit {
  transform-origin: top left;
}

.left-wide-mask {
  background-image: var(--leftWideMask);
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.left-narrow-mask {
  background-image: var(--leftNarrowMask);
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.right-narrow-mask {
  background-image: var(--leftNarrowMask);
  transform: rotateZ(180deg);
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.right-wide-mask {
  background-image: var(--rightMask);
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.loading-action {
  background: url('../assets/images/loading.png') no-repeat;
  background-size: 100% 100%;
  animation: rotation 3s linear infinite;
}
@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
